import { onCellStandard } from '../../helpers/helpers'
import { DataSourceItem } from '../../shipments-page'
import { ShipmentColumn } from '../../types/column-types'

export const stampWidthColumn: ShipmentColumn = {
    dataIndex: ['stamp', 'width'],
    title: 'Ш',
    width: 35,
    render: (v: number, r: DataSourceItem) =>
        r.withoutCutting ? r.virtualStamp?.width : (r.stamp?.width ?? v),
    onCell: onCellStandard,
}
